import type { SvgIconComponent } from '@mui/icons-material';
import {
  ChurchRounded,
  GroupsRounded,
  MenuBookRounded,
  PublicRounded,
  SchoolRounded,
  VolunteerActivismRounded,
} from '@mui/icons-material';
import type { LandingPillarIcon } from '@dosfilos/domain';

/** Los íconos que un seminario puede elegir para sus pilares (landing y editor). */
export const PILLAR_ICON: Record<LandingPillarIcon, SvgIconComponent> = {
  book: MenuBookRounded,
  people: GroupsRounded,
  school: SchoolRounded,
  church: ChurchRounded,
  heart: VolunteerActivismRounded,
  globe: PublicRounded,
};
